import {DashboardComponentState} from "../components/pages/dashboard/components/interfaces";

declare global {
    interface Window {
        dashboardComponentStates: Record<string, DashboardComponentState>
        dashboardState: "loading" | "finished" | "error"
    }
}

export const dashboardComponentStateCallback = (state: DashboardComponentState) => {
    if (!window.dashboardComponentStates) {
        window.dashboardComponentStates = {}
    }

    window.dashboardComponentStates[state.id] = state
}

export const getAllDashboardComponentStates = () => {
    if(!window.dashboardComponentStates) {
        window.dashboardComponentStates = {}
    }

    return window.dashboardComponentStates
}

export const getDashboardComponentState = (id: string) => {
    if(!window.dashboardComponentStates) {
        window.dashboardComponentStates = {}
    }

    return window.dashboardComponentStates[id]
}

export const setDashboardState = (state: "loading" | "finished" | "error") => {
    window.dashboardState = state
}

export const getDashboardState = () => {
    return window.dashboardState || "loading"
}